import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { EmptyState } from './ui';

const EMPTY_ROLES = [];

const ProtectedRoute = ({ children, requiredRoles = EMPTY_ROLES }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner size-12"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles.length > 0) {
    const userRole = user.role?.toLowerCase();
    const hasRole = requiredRoles.some(role => {
      if (role === 'travel lead') return userRole === 'travel lead' || user.is_travel_lead || userRole === 'admin';
      if (role === 'coordinator') return userRole === 'coordinator' || userRole === 'admin';
      if (role === 'admin') return userRole === 'admin';
      return userRole === role;
    });

    if (!hasRole) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center p-6">
          <EmptyState.AccessDenied
            action={{ label: 'Back to Dashboard', onClick: () => navigate('/dashboard') }}
          />
        </div>
      );
    }
  }

  return children;
};

export default ProtectedRoute;
